import { Table } from "melco-ui";
import { useTranslation } from "react-i18next";
import { TrackingTrackingModelsAnalyticsDownloadDailySummary } from "melco-shared-logic";
import { useDownloadDetail } from "../../hooks/reports/useDownloadDetail";

type UserDownloadDetailListProps = {
  selectedRowType: string;
  selectedUserId: string;
  selectedRowProductCode: string;
  reportsRawData:
  | TrackingTrackingModelsAnalyticsDownloadDailySummary[]
  | undefined;
};
export const UserDownloadDetailList: React.FC<UserDownloadDetailListProps> = ({
  selectedUserId,
  reportsRawData,
  selectedRowProductCode,
  selectedRowType
}) => {
  const { t } = useTranslation();
  const { DownloadDetailData } = useDownloadDetail(
    selectedUserId,
    reportsRawData,
    selectedRowType,
    selectedRowProductCode
  );

  const columns = [
    {
      title: t("reports.table.column.date"),

      width: 25,
      render: (rowObj: any) => (
        <div>
          <span>
            {rowObj.date ? new Date(rowObj.date).toLocaleString() : ""}
          </span>
        </div>
      ),
    },
    {
      title: t("reports.table.column.unique_downloads"),
      key: "unique_files",
      dataIndex: "unique_files",
      //  sorter: true,
      width: 35,
    },
    {
      title: t("reports.table.column.total_downloads"),
      key: "total_files",
      dataIndex: "total_files",
      //sorter: true,
      width: 30,
    },
  ];

  return (
    <>
      <Table
        showSorterTooltip={false}
        dataSource={DownloadDetailData}
        columns={columns}
        pagination={false}
        rowKey="r"
        noDataMessage={t("reports.basic.no_reports_message")}
      />
    </>
  );
};
